module.exports = __webpack_public_path__ + "img/40_48.d7bfbbcd.png";